import { NgModule } from "@angular/core";
import { PassAlertFailControlComponent } from "./pass-alert-fail-control.component";
import { PassAlertFailControlNodeComponent } from "./pass-alert-fail-control-node.component";
import { PassAlertFailControlItemComponent } from "./pass-alert-fail-control-item.component";
import { TreeModule } from "angular-tree-component";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        TreeModule
    ],
    declarations: [
        PassAlertFailControlComponent,
        PassAlertFailControlNodeComponent,
        PassAlertFailControlItemComponent
    ],
    exports: [
        PassAlertFailControlComponent
    ]
})
export class PassAlertFailControlModule {}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/form/pass-alert-fail-control.module.ts